import { PAGE_SIZE } from '../constants/general';
import {
  ASSIST_RELEASE_ISSUE_CREATED,
  ASSIST_RELEASE_ISSUE_UPDATED,
} from '../constants/integration-constants';
import {
  ENTITY_SELECTION_PARAMS,
  ALL_QUERY_FILTER_PARAMS,
} from '../constants/job-query-filter-params';
import {
  compressFilters,
  shouldCompressFilters,
} from '@app/helpers/url-compression';
import {
  DEFAULT_SELECTED_SORT,
  DEFAULT_SELECTED_SORT_ORDER,
} from '@app/components/ChatsContainer/ChatInbox/constants';

const MANY_FILTERS_THRESHOLD = 10;

export const getOperators = (items, groups, operatorIds, userId) => {
  let operators = [];
  if (
    Object.keys(groups || {})?.length === 0 &&
    Object.keys(operatorIds || {})?.length === 0 &&
    !items?.allChats &&
    !items?.unassigned &&
    !items?.myChats &&
    !items?.secondaryOperatorIds
  ) {
    // default to my chats
    return [userId];
  }
  if (items?.myChats) {
    operators.push(userId);
  }
  if (items?.unassigned) {
    operators.push('unassigned');
  }
  if (Object.keys(operatorIds || {})?.length > 0) {
    operators = [...operators, ...Object.keys(operatorIds || {})];
  }

  return operators;
};

export function buildInboxFilterObject(customFilters, userId) {
  const {
    onlyActive = false,
    groups = {},
    operatorIds = {},
    items = {},
    tags = [],
    secondarySort,
    secondaryOrder,
    refineBy = null,
  } = customFilters?.inboxFilters || {};

  const filterObject = {
    limit: customFilters?.limit || PAGE_SIZE,
    order:
      customFilters?.inboxFilters?.order ||
      customFilters?.order ||
      DEFAULT_SELECTED_SORT_ORDER,
    sort:
      customFilters?.inboxFilters?.sort ||
      customFilters?.sort ||
      DEFAULT_SELECTED_SORT,
  };

  if (secondarySort && secondaryOrder) {
    filterObject.secondarySort = secondarySort;
    filterObject.secondaryOrder = secondaryOrder;
  }

  if (onlyActive === true) {
    filterObject.onlyActive = onlyActive;
  }

  if (customFilters?.isOpen !== undefined && customFilters.isOpen !== null) {
    filterObject.isOpen = customFilters.isOpen;
  }

  if (Object.keys(groups)?.length > 0) {
    filterObject.groupIds = Object.keys(groups);
  }

  if (customFilters?.inboxFilters) {
    const allOperatorIds = getOperators(items, groups, operatorIds, userId);
    if (allOperatorIds?.length > 0) {
      filterObject.operatorIds = allOperatorIds;
    }
    if (items?.secondaryOperatorIds) {
      filterObject.secondaryOperatorIds = [userId];
    }
    if (refineBy) {
      filterObject[refineBy] = true;
    }
  }

  if (!tags.includes('all') && tags.length > 0) {
    filterObject.tags = tags;
  }

  return filterObject;
}

export const parseParams = (params) =>
  Object.keys(params)
    .map((p) =>
      Array.isArray(params[p])
        ? `${p}[]=${params[p].join(`&${p}[]=`)}`
        : `${encodeURIComponent(p)}=${encodeURIComponent(params[p])}`,
    )
    .join('&');

export const parseInboxFilterParams = async (params) => {
  const filterParams = ENTITY_SELECTION_PARAMS;
  const hasManyFilters = filterParams.some((key) => {
    const value = params[key];
    return Array.isArray(value) && value.length > MANY_FILTERS_THRESHOLD;
  });

  if (hasManyFilters) {
    try {
      const filterData = {};
      filterParams.forEach((key) => {
        if (params[key]) {
          filterData[key] = params[key];
        }
      });

      if (params.myChats) filterData.myChats = params.myChats;
      if (params.unassigned) filterData.unassigned = params.unassigned;
      if (params.secondaryOperatorIds)
        filterData.secondaryOperatorIds = params.secondaryOperatorIds;
      if (params.refineBy) filterData.refineBy = params.refineBy;

      if (shouldCompressFilters(filterData)) {
        const compressed = await compressFilters(filterData);
        const nonFilterParams = Object.keys(params).reduce((acc, key) => {
          if (ALL_QUERY_FILTER_PARAMS.includes(key)) {
            return acc;
          }
          acc[key] = params[key];
          return acc;
        }, {});

        const nonFilterString = Object.keys(nonFilterParams)
          .map((p) =>
            Array.isArray(nonFilterParams[p])
              ? `${p}[]=${nonFilterParams[p].join(`&${p}[]=`)}`
              : `${encodeURIComponent(p)}=${encodeURIComponent(nonFilterParams[p])}`,
          )
          .join('&');

        return nonFilterString
          ? `filters=${encodeURIComponent(compressed)}&${nonFilterString}`
          : `filters=${encodeURIComponent(compressed)}`;
      }
    } catch (error) {
      console.warn(
        'Failed to compress filters, using regular encoding:',
        error,
      );
    }
  }

  return parseParams(params);
};

export function buildPaginatedQueryString(pageParam, filters) {
  const params = {
    ...filters,
    page: pageParam,
  };

  return params ? parseParams(params) : '';
}

export const filterTotalLossAssistEvents = (response) => {
  const totalLossAssistEvents = [
    ASSIST_RELEASE_ISSUE_CREATED,
    ASSIST_RELEASE_ISSUE_UPDATED,
  ];
  return response.data.filter(
    (event) => !totalLossAssistEvents.includes(event.eventType),
  );
};
